import { action, observable } from "mobx"
import moment from "moment"
import LineItem from "sdk/LineItem"
import shop from "shop/shop"
import exportCSV from "util/exportCSV"

class ExportStore {

  @observable positions = []
  @observable positionById = new Map()

  @observable sum = 0
  @observable productCount = 0
  @observable positionCount = 0
  @observable loading = false

  _loadingItems = 0

  @action
  async setPosition( index, articleNumber ) {
    let lineItem = this.positions[ index ]
    let dirty = lineItem.dirty

    this._loadingItems++

    await lineItem.fetchProduct( articleNumber )
      .catch( () => {
        this._loadingItems--
      } )

    this._loadingItems--

    this.loading = this._loadingItems > 0

    if ( !dirty ) {
      this.checkDirty()
    }
  }

  toCart = () => {
    this.positions
      .filter( p => p.product )
      .map( pos => {
        return pos.product
      } )
      .forEach( product => {
        shop.cart.add( product )
      } )
  }


  export = () => {
    const headers = {
      article_nr: "Artikel Nummer",
      count     : "Anzahl",
      desc      : "Beschreibung (optional)"
    }

    const itemsFormatted = this.positions
      .filter( p => p.product )
      .map( pos => {
        return {
          article_nr: pos.product.article_nr,
          count     : pos.product.count,
          desc      : pos.product.desc.des.split( "," ).join( " " )
        }
      } )

    console.log( "EXPORT", { itemsFormatted } )
    const filename = `orderlist-${process.env.REACT_APP_ID}-${moment().format( "YYYY-MM-DD--HH-mm" )}`
    exportCSV( headers, itemsFormatted, filename ); // call the exportCSVFile() function to process the JSON and trigger the download
  }


  @action
  calculate() {
    let sum = 0
    let productCount = 0
    let positionCount = 0
    let productById = new Map()

    this.positions.forEach( position => {
      let product = position.product
      if ( product ) {
        let p = productById.get( product.map_id )
        productCount += product.count
        if ( !p ) {
          positionCount++
        }
        sum += product.count * product.unit_multi * product.price

      }
    } )

    this.sum = sum
    this.productCount = productCount
    this.positionCount = positionCount
  }

  @action
  remove( index ) {
    this.positions = this.positions.filter( ( item, i ) => i !== index )
    this.checkDirty()
    this.calculate()
  }

  constructor() {
    // this.positions.push( new LineItem( "D-0100HIVE475-22", 1 ) )
    // this.positions.push( new LineItem( "MOV-A-19063-161", 1 ) )
    this.positions.push( new LineItem() )
  }
}

const exportStore = new ExportStore()

export default exportStore


// WEBPACK FOOTER //
// ./src/stores/exportStore.js